import { StoreEditor } from './RadStore';

export default function NoveltyStore() {
  return (
    <StoreEditor
      prefix="novelty_"
      storeLabel="Novelty Store"
      storeBaseUrl="https://novelty-one-main.pages.dev"
    />
  );
}
